import Operation from './Operation.js';
import AddEvent from './AddEvent.js';

class AddDeterministicEvent extends AddEvent {
    set currentEvent(x) {
        this.mixByType.currentEvent = x;
    }

    set currentEvent(x) {
        this.mixByType.currentEvent = x;
    }

    execute() {
        super.execute();
        this.currentEvent = this.event;
    }
}

export default AddDeterministicEvent;
